import { Box, Stack, Typography, Avatar, Chip } from "@mui/material";
import { Circle } from "@mui/icons-material";

const AgentCard = ({ agent, handleOpenSlidingPanel }) => {
	// Deactivated agents are excluded from every commission computation, so the
	// account state is what belongs here — not the license status it used to show.
	const optedIn = agent?.suspended == 0;
	const { bg, text } = optedIn
		? { bg: "success.verylight", text: "success.dark" }
		: { bg: "error.verylight", text: "error.dark" };

	return (
		<Box
			p={1}
			onClick={() => handleOpenSlidingPanel(agent)}
			sx={{
				border: "1px solid",
				borderColor: "secondary.lightbgcolor",
				borderRadius: "8px",
				cursor: "pointer",
				transition: "all 0.2s ease-in-out",
				"&:hover": {
					boxShadow: "0 4px 12px rgba(26, 63, 122, 0.10)",
					borderColor: "primary.light",
					transform: "translateY(-2px)",
				},
			}}
		>
			<Box
				sx={{
					position: "relative",
					p: 2,
					border: "1px solid",
					borderColor: "secondary.lightbgcolor",
					backgroundColor: "background.default",
					borderRadius: "8px",
				}}
			>
				{/* Status */}
				<Stack spacing={1} direction="row" alignItems="center" sx={{ position: "absolute", top: 15, right: 15 }}>
					<Circle sx={{ fontSize: 12, color: agent?.suspended == 0 ? "success.main" : "error.main" }} />
					<Typography variant="body2" color="text.secondary">
						{agent?.suspended == 0 ? "Active" : "Deactivated"}
					</Typography>
				</Stack>

				<Box mb={1}>
					<Avatar
						src={agent?.avatar}
						sx={{
							width: 70,
							height: 70,
							filter: agent?.suspended === 1 ? "grayscale(40%) brightness(50%)" : "none",
							transition: "filter 0.3s",
							bgcolor: "transparent",
						}}
					>
						{agent?.display_name?.charAt(0)?.toUpperCase()}
					</Avatar>
					<Typography variant="h6" mt={1} color="text.primary">
						{agent?.display_name}
					</Typography>
				</Box>

				<Box mb={2}>
					<Typography variant="body2" color="text.secondary">
						{agent?.email}
					</Typography>
					{agent?.agency_name && (
						<Typography variant="body2" color="text.secondary">
							{agent.agency_name}
						</Typography>
					)}
				</Box>

				<Chip
					label={optedIn ? "Opted In for Service" : "Opted Out for Service"}
					size="small"
					sx={{
						backgroundColor: bg,
						color: text,
						fontWeight: 500,
						fontSize: "0.75rem",
					}}
				/>
			</Box>

			<Box p={2}>
				<Stack direction="row" alignItems="center" mb={1.5}>
					<Box flex={1}>
						<Typography variant="body2" color="text.secondary">
							Phone
						</Typography>
						<Typography variant="body2" color="text.primary">
							{agent?.phone || "Not Set"}
						</Typography>
					</Box>
					<Box flex={1}>
						<Typography variant="body2" color="text.secondary">
							NPN
						</Typography>
						<Typography variant="body2" color="text.primary">
							{agent?.npn_number || "Not Set"}
						</Typography>
					</Box>
				</Stack>

				<Stack direction="row" alignItems="center">
					<Box
						flex={1}
						sx={{
							display: "inline-block",
							color: "primary.main",
							cursor: "pointer",
							textDecoration: "underline",
							"&:hover": { textDecoration: "underline" },
							fontWeight: 500,
							mt: 2.5,
						}}
					>
						<Typography variant="body2">View More Details</Typography>
					</Box>
				</Stack>
			</Box>
		</Box>
	);
};
export default AgentCard;
